import { IAddress, AddressModel } from "./Address"
import { TenantUserFields } from "./TenantUserFields";
import { v4 as uuid } from "uuid";
import {Model} from "./base/Model";
import {Collection} from "./base/Collection";

enum GenderEnum {
  female = "F",
  male = "M",
  other = "U",
}
 interface TenantFields {

[key: string]: string;

} 

    export interface IUser {
      key: string,
      initials: string,
      first_name: string,
      preposition: string,
      last_name: string,
      gender: GenderEnum,
      email: string,
      company_email: string,
      phone: string,
      mobile: string,
      address: Array<IAddress>
      type: number;
      userfields: TenantUserFields;
      roles: Array<any>;
      companyFields?: TenantFields;
      ppc_user_fields?: any;      
    }

    export class UserModel extends Model  {
        key: string = "";
      initials: string = "";
      first_name: string = "";
      preposition: string = "";
      last_name: string = "";
      gender: GenderEnum = GenderEnum.other;
      email: string = "";
      phone: string = "";
      mobile: string = "";
      type:number = 0;
      address: AddressModel[] = [];
      userfields: TenantUserFields = new TenantUserFields();
      roles: any[] = [];
      companyFields?: TenantFields;
      ppc_user_fields?: any;
        changed:any = {}
  constructor(data = null, usertype = null) {
      super(data);
      
      this.createModel(data);
      if(data) {
          //this.syncData(data);
      }
      if(usertype) {
        this.type = usertype;
    }
  }  


handler1 = {
  set(obj, prop, value) {
      console.debug(obj)
      
      console.debug(value)
      console.debug(obj.changed[prop])
      obj.changed[prop] = obj[prop];
      Reflect.set(obj, 'changed', obj.changed);
    if (prop === "eyeCount" && value % 2 !== 0) {
      
    } else {
      return Reflect.set(obj, prop, value);
    }
  },
};


    public getProxy(data) {
        const proxy1 = new Proxy(this, this.handler1);
        return proxy1;        
        }

      public syncData(data) {
            if(data) {
                Object.keys(data).map((item) => {
                        this[item] = data[item];
                });
            }
      }
  
      
      createAddress =(data = null) => {
          let address = new AddressModel(data);
          this.address.push(address);
          
          //this.company_address.push( address );
      }
    }